import React from "react";
import {
	styledSystem as ss,
	theme,
} from ".";

export type ICheckboxProps = ss.ICommonProps & ss.IFontSizeProps & ss.ITypographyProps &
	{
		note?: any;
		block?: boolean;
	}
;

// Checkbox container
export const CheckboxContainer = ss.styled.div<ICheckboxProps>`
	display: ${props => props.block ? "block" : "inline-block" };
	${ss.COMMON}
	${ss.FONTSIZE}
	${ss.TYPOGRAPHY}
`;
CheckboxContainer.defaultProps = {
	theme,
};

export const CheckboxLabel = ss.styled.label`
	display: block;
	padding-left: 20px;
	vertical-align: middle;
	font-size: inherit;
	font-weight: normal;
	display: flex;
	align-items: center;
	line-height: 1;
`;

export const CheckboxNote = ss.styled.p`
	display: block;
	margin: 0;
	opacity: 0.8;
	padding-left: 20px;
	${ss.FONTSIZE({fontSize: "small"})}
	${ss.TYPOGRAPHY({fontWeight: "normal"})}
`;
CheckboxNote.defaultProps = {
	theme,
};

export const StyledCheckbox = ss.styled.input`
	margin-left: -20px;
	margin-right: 5px;
	float: left;
`;

StyledCheckbox.defaultProps = {
	type: "checkbox",
}

export const Checkbox = ({children, ...props}: ICheckboxProps & Omit<JSX.IntrinsicElements["input"], "ref">) => {
	return (
		<CheckboxContainer {...props} color={props.disabled ? "muted" : props.color}>
			<CheckboxLabel>
				<StyledCheckbox {...props} />
				<span>{children}</span>
			</CheckboxLabel>
			{ props.note && <CheckboxNote>{props.note}</CheckboxNote> }
		</CheckboxContainer>
	);
}

export const Radio = ss.styled(Checkbox)``; Radio.defaultProps = { type: "radio" };
